/**
 * База URL для XHR к `/ajax/...` и `/local/...`.
 *
 * В **development** (только `npm run serve`): по умолчанию пустая строка — запросы на origin dev-server,
 * прокси в `vue.config.js` шлёт их на `VUE_APP_BE_URL` (обход отказа :80/https в браузере).
 * Явно отключить: `VUE_APP_DEV_PROXY_API=false` или `0` в `.env.development`.
 *
 * В **production** (сборка в `app`) всегда полный `VUE_APP_BE_URL` из `.env.production` / CI.
 */
function isDevDirectApiDisabled(): boolean {
    if (process.env.NODE_ENV !== 'development') {
        return false;
    }
    const v = (process.env.VUE_APP_DEV_PROXY_API ?? '').trim().toLowerCase();
    if (v === 'false' || v === '0' || v === 'off' || v === 'no') {
        return false;
    }
    return true;
}

export function getApiBaseUrl(): string {
    if (isDevDirectApiDisabled()) {
        return '';
    }
    const base = process.env.VUE_APP_BE_URL;
    if (base == null || String(base).trim() === '') {
        throw new Error('VUE_APP_BE_URL is not set');
    }
    return String(base).replace(/\/$/, '');
}

/** Полный origin Bitrix для ссылок в админку и статику (`/bitrix/...`, `/upload/...`). */
export function getPublicBackendOrigin(): string {
    const base = process.env.VUE_APP_BE_URL;
    if (base == null || String(base).trim() === '') {
        throw new Error('VUE_APP_BE_URL is not set');
    }
    return String(base).replace(/\/$/, '');
}
